import React from 'react'
import PropTypes from 'prop-types'
import { Article } from '../components/Article'
import board1 from '../images/board1.jpg'

export function A01({ index }) {
  return (
    <Article
      index={index}
      heading="The entrepreneur builds an MVP app or service."
      image={board1}
      imageDescription="Our entrepreneur, Alice, brainstorms ideas."
    >
      <p className="two-column">
        Alice, our theoretical entrepreneur, has developed a software
        application called CanCan, a video-sharing social networking app similar
        to TikTok and Snapchat. Her minimum viable product version of CanCan is
        a web app optimized for mobile experience that allows users to upload
        and watch videos.
        <br />
        <br />
        The app's front end is JavaScript and its back-end logic is written in
        Motoko. Alice deploys the full CanCan application, both front-end and
        back-end code, to a canister on the Internet Computer.
        <br />
        <br />
        From the developer's point of view, Alice has authored the code,
        compiled it to WebAssembly (Wasm), and deployed it to an Internet
        Computer canister, where it lives in a serverless Wasm-based environment
        that isn't owned or controlled by any one company or entity. The app's
        code and state are replicated in multiple servers around the world — no
        single authority would be capable of shutting down CanCan, for example.
        The app's latency and user experience are so fluid that CanCan users are
        entirely unaware that the app is running on the Internet Computer rather
        than conventional proprietary computing providers.
      </p>
    </Article>
  )
}

A01.propTypes = {
  index: PropTypes.number.isRequired,
}
